<template>
  <div id="app">
    <SocketError />
    <router-view class="view" />
  </div>
</template>

<script>
import SocketError from './components/SocketError.vue';
// Global functionality:

Array.prototype.equals = function(arr2) {
  return (
    this.length === arr2.length &&
    this.every((value, index) => value === arr2[index])
  );
};
Array.prototype.contains = function(arr2) {
  return this.some((arr) => arr.equals(arr2));
};
Array.prototype.last = function() {
  return this[this.length - 1];
};

export default {
  name: 'App',
  components: {
    SocketError,
  },
  data: () => ({
    serverVersion: null,
  }),
  created() {
    this.$store.dispatch('init');

    // Ctrl + K -> Cylce through routes
    document.addEventListener(
      'keydown',
      (e) => {
        if (e.ctrlKey && e.key.toLowerCase() === 'k') {
          e.preventDefault();
          e.stopPropagation();
          let routes = this.$router.options.routes;
          routes = routes.map((r) => r.path);
          routes = routes.filter((r) => r !== '*');
          let idx = routes.indexOf(this.$router.currentRoute.path) + 1;
          if (idx >= routes.length) idx = 0;

          this.$router.push({
            path: routes[idx],
            query: this.$router.currentRoute.query,
          });
        }
      },
      false
    );

    this.toHistoryRoute();

    // Detect updates
    this.$store.state.socket.on('server-version', (serverVersion) => {
      if (this.serverVersion != null && serverVersion != this.serverVersion) {
        // There's an update
        this.toHistoryRoute(true);
      }
      this.serverVersion = serverVersion;
    });
  },
  methods: {
    toHistoryRoute(forceReload = false) {
      if (window.location.hash.startsWith('#/')) {
        // Redirect to history route if it is an old hash route
        const hash = window.location.hash;
        window.location.hash = '';
        window.location.pathname = hash.replace(/^#/, '');
      } else if (forceReload) {
        // Or just refresh the page
        window.location.reload();
      }
    },
  },
};
</script>

<style lang="scss">
html,
body,
#app {
  width: 100%;
  height: 100%;
  overflow: hidden;

  font-family: Lato;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #fff;

  background: $basic-dark;
}

#app {
  display: flex;
  flex-direction: column;
}

.view {
  flex-grow: 1;
}

// Global styles
@import '@/styles/global/main.scss';
</style>
